import { z } from "zod";
import { INCIDENT_TYPE, DESCRIPTION } from "./consts";

export const schema = z.object({
  [INCIDENT_TYPE]: z.string().min(1, "This field is required"),
  [DESCRIPTION]: z.string().optional(),
});

export type AddFormValues = z.infer<typeof schema>;
